import { render } from "./userRegister.vue?vue&type=template&id=4c91a7ad&scoped=true"
import script from "./userRegister.vue?vue&type=script&lang=js"
export * from "./userRegister.vue?vue&type=script&lang=js"

import "./userRegister.vue?vue&type=style&index=0&id=4c91a7ad&scoped=true&lang=css"
import "./userRegister.vue?vue&type=style&index=1&id=4c91a7ad&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c91a7ad"]])

export default __exports__